import { render, staticRenderFns } from "./tax-invoices.vue?vue&type=template&id=4664eb82&scoped=true"
import script from "./tax-invoices.vue?vue&type=script&lang=ts"
export * from "./tax-invoices.vue?vue&type=script&lang=ts"
import style0 from "./tax-invoices.vue?vue&type=style&index=0&id=4664eb82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4664eb82",
  null
  
)

export default component.exports